import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {CardWithHeaderComponent} from "../card-with-header/card-with-header.component";
import {GreedyScrollPanelComponent} from "../greedy-scroll-panel/greedy-scroll-panel.component";
import {Ripple} from "primeng/ripple";
import {TranslationPipe} from "../../../pipes/translation.pipe";
import {DocumentShortInfoDto, DocumentType} from '../../../api/api-client';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-image-grid',
    imports: [
        ButtonDirective,
        CardWithHeaderComponent,
        GreedyScrollPanelComponent,
        Ripple,
        TranslationPipe
    ],
  templateUrl: './image-grid.component.html',
  styleUrl: './image-grid.component.scss',
})
export class ImageGridComponent {
  @Input() pinnedImages: DocumentShortInfoDto[] = [];
  @Input() notPinnedImages: DocumentShortInfoDto[] = [];
  @Input() pinnedTranslationKey:string ="DocumentList.Pinned"
  @Input() pinLock!: boolean;
  @Input() deletePinnedLock!: boolean;

  @Output() onPinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onUnpinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onDeleteDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onViewDocument = new EventEmitter<string>();
  @Output() onAddDocument = new EventEmitter<DocumentType>();
  @Output() onEditDocument = new EventEmitter<DocumentShortInfoDto>();

  getDate(date: DateTime) {
    return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
  }

  pinDocument(document: DocumentShortInfoDto) {
    this.onPinDocument.emit(document);
  }

  unpinDocument(document: DocumentShortInfoDto) {
    this.onUnpinDocument.emit(document);
  }

  openDeleteDocumentDialog(document: DocumentShortInfoDto) {
    this.onDeleteDocument.emit(document);
  }

  openViewDocumentDialog(documentId: string) {
    this.onViewDocument.emit(documentId);
  }

  openAddDocumentDialog(type: DocumentType) {
    this.onAddDocument.emit(type);
  }

  openEditDocumentPage(document: DocumentShortInfoDto) {
    this.onEditDocument.emit(document);
  }

}
